import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss']
})
export class RegionComponent implements OnInit {

  constructor(
    private router :Router,
  ) { }

  ngOnInit() {
  }
  /**
   * 0: cali
   * 1: palmira
   * 2: buga
   * 3: yumbo
   */
  escogerRegion(region){
      localStorage.setItem("page","profile");
      localStorage.setItem("region",region);
      this.router.navigate(['/profile/pedido']);      
  }

}
